<!-- <p-dropdown (onChange)="addUser($event.value)" [options]="users" [(ngModel)]="user"
	placeholder="Add User" optionLabel="name"></p-dropdown> -->


<div class="users-block">
	<div class="user" *ngFor="let member of members">
		<div class="member manager" *ngIf="projectManagerId === member.user.id">
			<div class="username">
				{{member.user.name}}
			</div>
			<div class="manager-label mark-label">
				<span>PM</span>
			</div>
		</div>
		<div matRipple [matRippleCentered]="true" class="member" (click)="toggleUser(member.user.id, member.attached)"
			*ngIf="projectManagerId !== member.user.id">
			<div class="username">
				{{member.user.name}}
			</div>
			<div class="checkmark mark-label" [ngClass]="{'attached-member': member.attached}">
				&#10004;
			</div>
		</div>
	</div>
</div>